import * as dayjs from "dayjs";
import goalSeek from "goal-seek";

export interface IPmtAcquisitionCalculateParams {
    amount: number;
    tenure: number;
    interestRate: number;
    loanDate: Date,
    dueDate: Date;
}

export const adjustPmtWithAcquisition = (params: IPmtAcquisitionCalculateParams): number => {
    const {
        amount,
        tenure,
        interestRate,
        loanDate,
        dueDate,
    } = params;
    let approxPayment = 0;

    const fn = (paymentValue: number) =>
        calculateApproximatedValue({
            amount,
            tenure,
            interestRate,
            loanDate,
            dueDate,
        }, paymentValue);

    const fnParams = [approxPayment];

    const result = goalSeek({
        fn,
        fnParams,
        percentTolerance: 0.001,
        maxIterations: 10_000,
        maxStep: 1_000_000,
        goal: 0,
        independentVariableIdx: 0
    });

    return result;
}

export const calculateApproximatedValue = (request: IPmtAcquisitionCalculateParams, payment: number): number => {
    let baseDate = dayjs(request.loanDate);
    let startDate = dayjs(request.dueDate);
    let totalAcquisition = 0;
    
    for (let index = 0; index < request.tenure; index++) {
        let dateToAccrual = startDate.add(index, 'month');
        let amountOfDays = dateToAccrual.diff(baseDate, 'day');

        const acquisition = installmentAcquisition(
            payment,
            request.interestRate,
            amountOfDays
        );

        totalAcquisition += acquisition;
    }

    const approximatedValue = Number((totalAcquisition - request.amount).toFixed(2));
    
    return approximatedValue;
}

const installmentAcquisition = (payment: number, interestRate: number, amountOfDays: number): number => {
    const averageMonthDays = 365 / 12;
    const monthlyRate = interestRate / 100;

    return (payment / Math.pow((1 + monthlyRate), amountOfDays / averageMonthDays));
}